import type { WalletDto } from "@umi/api/schemas/wallet";
import type { ChainTag } from "@umi/shared/chains";
import { useStorage } from "@vueuse/core";



export const LocalStorage = {
  jwt:           useStorage<string | null>("umi.jwt", null),
  chainTag:      useStorage<ChainTag>("umi.chainTag", "ETHEREUM"),
  wallets:       useStorage<WalletDto[]>("umi.wallets", []),
  browserWallet: useStorage<"PHANTOM" | "METAMASK" | null>("umi.browserWallet", null),
  theme:         useStorage<"light" | "dark">("umi.theme", "light"),
};
